var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "46137C12-C34F-4CEB-B1BA-337004C2741D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dise\\xF1o-enviar-presupuesto",
    transform: "translate(-758.000000, -675.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solicitudes-Copy-2",
    transform: "translate(727.500000, 665.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(30.750000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24972,5.21148 L2.4786,5.9826 L4.9572,8.4612 L10.4652,2.9532 L9.69408,2.18208 L4.9572,6.91896 L3.24972,5.21148 Z M9.9144,6.258 C9.9144,8.68152 7.93152,10.6644 5.508,10.6644 C3.08448,10.6644 1.1016,8.68152 1.1016,6.258 C1.1016,3.83448 3.08448,1.8516 5.508,1.8516 C5.94864,1.8516 6.3342,1.90668 6.71976,2.01684 L7.6010616,1.13556 C6.94008,0.91524 6.22404,0.75 5.508,0.75 C2.4786,0.75 5.06261699e-14,3.2286 5.06261699e-14,6.258 C5.06261699e-14,9.2874 2.4786,11.766 5.508,11.766 C8.5374,11.766 11.016,9.2874 11.016,6.258 L9.9144,6.258 Z",
    id: "Shape"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPres);
export default __webpack_public_path__ + "static/media/check-pres.8a0a643996395cfb70f7495a645a1560.svg";
export { ForwardRef as ReactComponent };